import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { hAll, headersAllTenantsAppend } from 'src/app/shared/classes/utils/utils';
import { ConfigService } from 'src/app/shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { LoggerService, SignatureView, TripManifestRec } from '../../../../shared/sdk';
import { HelperService as ConsumerHelperService } from '../../../consumer/services/helper.service';
import { HelperService } from '../../services/helper.service';
import { DataSourceOptions } from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import moment from 'moment';
import { dxStoreLoadHooks, gqlMongoLoad } from 'src/app/shared/classes/loopback-custom-store/generic/store.utils';

@Component({
  selector: 'app-dlg-client-trips-history',
  templateUrl: './dlg-client-trips-history.component.html',
  styleUrls: ['./dlg-client-trips-history.component.scss'],
  providers: [ConsumerHelperService, HelperService],
})
export class DlgClientTripsHistoryComponent implements OnInit {
  dso: DataSourceOptions;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { consumerId: number; consumerName: string },
    protected logger: LoggerService,
    private dss: DataSourceService,
    public config: ConfigService,
    public helper: HelperService,
    protected dialog: MatDialog,
    public consumerHelper: ConsumerHelperService,
  ) {
    this.buildDso();
  }

  ngOnInit() {}

  private buildDso() {
    const so = this.dss.getStoreOptions(SignatureView, SignatureView, false);
    so.customHeaders = headersAllTenantsAppend;
    so.customFilter = {
      where: { consumerId: this.data.consumerId },
      order: ['ctime DESC'],
    };
    const store = new CustomStore(so);

    dxStoreLoadHooks(store, undefined, async (args: any[], [signs]: any[]) => {
      const aggregate = [
        {
          $match: {
            _tripId: { $in: signs.map(s => s.vTripId).filter(Boolean) },
            'Delivery Name': { $exists: true, $ne: null },
          },
        },
        {
          $project: {
            _tripId: { $substr: ['$_tripId', 0, { $subtract: [{ $strLenCP: '$_tripId' }, 1] }] },
            'Delivery Name': 1,
          },
        },
      ];
      const res = await gqlMongoLoad(this.dss, 'ExportsDataCache', {}, aggregate).toPromise();
      const tripMap = res.reduce((p, t) => ({ ...p, [t._tripId]: t['Delivery Name'] }), {});
      return [
        signs.map(s => {
          if (!s.vTripId) return s;
          const tripKey = s.vTripId.substr(0, s.vTripId.length - 1);
          return { ...s, deliveryName: tripMap[tripKey] || '' };
        }),
      ];
    });

    this.dso = { store } as DataSourceOptions;
  }

  getDriverName(signature: SignatureView): string {
    return (signature && `${signature.employee_person_lastname}, ${signature.employee_person_firstname}`) || '';
  }

  getStatusText(signature: SignatureView): string {
    return (signature && HelperService.TRIP_STATUSES_MAP[signature.status]) || '';
  }

  formatTimeString(time: string): string {
    if (!time) return '';
    return moment(time, 'HH:mm:ss').format('h:mm A');
  }

  getMapURL(v) {
    const location = `${v.lat},${v.lng}`;
    return `https://maps.google.com/?q=${location}&ll=${location}&z=11`;
  }

  grid_onSelectionChanged(e) {}
}
